// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7281":"805f23b7a43f8f2b","7500":"1a99aa21a9242bd2"}[chunkId] + ".css";
};